/* Reuses Shopify's existing event bus. No pixels, external requests or consent changes. */
(function () {
  'use strict';
  var names = new Set(['code_search', 'code_search_no_result', 'code_search_malformed', 'guide_view', 'article_view', 'app_link_click', 'compatibility_click', 'scanner_product_click', 'copy_code']);
  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }
  function publish(name, payload) {
    if (!names.has(name) || !allowed() || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    var data = {};
    if (/^[a-z0-9_-]{1,100}$/.test(payload.content_id || '')) data.content_id = payload.content_id;
    if (/^[PBCU][0-3][0-9A-F]{3}$/.test(payload.code || '')) data.code = payload.code;
    if (['found', 'not_covered', 'malformed', 'index_unavailable'].includes(payload.result)) data.result = payload.result;
    try { Promise.resolve(window.Shopify.analytics.publish('uth_' + name, data)).catch(function () {}); } catch (_) {}
  }
  document.addEventListener('uth:editorial-event', function (event) {
    var detail = event.detail || {};
    publish(detail.name, detail);
  });
  var viewed = false;
  function view() {
    if (viewed || !allowed()) return;
    var content = document.querySelector('[data-uth-content-type="news_article"]');
    if (!content) return;
    viewed = true;
    publish('article_view', {content_id: content.dataset.uthContentId});
  }
  view();
  document.addEventListener('visitorConsentCollected', view);
  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-uth-editorial-action]');
    if (!target || !target.closest('[data-uth-content-type="news_article"]')) return;
    var content = target.closest('[data-uth-content-id]');
    publish(target.dataset.uthEditorialAction, {content_id: content ? content.dataset.uthContentId : ''});
  });
})();
